import React, { useMemo } from "react";
import Image from "next/image";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";

import constants from "../../../utils/Constants";
import { removeInlineStyleColor } from "../../../utils/CommonFunctions";

import styles from "../../../styles/sass/privacy-policy.module.scss";
import BannerInner from "../../common-components/bannerinner/BannerInner";
import bannerImage from "../../../../public/assets/images/banner-img-top-6.jpg";

const { CMS_TYPES } = constants;
const pageParams = {
  type: CMS_TYPES.OTHER_PAGE,
  slug: "privacy-policy",
};

const bgImg = "/assets/images/privacy-policy.jpg";

const PrivacyPolicy = () => {
  const mPageDetails = useSelector(({ cms }) => {
    const boardKey = JSON.stringify(pageParams);

    const boards = cms.boards;
    const mPageDetailsId = boards[boardKey]?.list?.[0];
    return cms.cmsMap[mPageDetailsId] || {};
  });

  const content = useMemo(
    () => removeInlineStyleColor(mPageDetails?.description),
    [mPageDetails?.description]
  );

  return (
    <>
      <BannerInner title={"Privacy Policy"} imageSrc={bannerImage} />
      <section className={`mc_container_fluid p-spacerT p-spacerB ${styles["privacy-policy-container"]}`}
      >
        <div className="mc_row_new">
          <div className="mc_container_inner">
            <div className="mc_row_new">
                <div className={styles["content-container"]}
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default React.memo(PrivacyPolicy);
